import type { ReactNode } from 'react'
import { useState } from 'react'

export const useManageUserInput = ({
  renderedValueFromItem,
  inputValueAsText,
  valueKey,
  isFocused,
}: {
  renderedValueFromItem: ReactNode
  inputValueAsText: string
  valueKey: string | undefined
  // While focused the real input must carry its actual text, otherwise
  // Backspace has nothing to delete and the field becomes uneditable.
  isFocused: boolean
}) => {
  const [renderedValueKey, setRenderedValueKey] = useState(valueKey)
  const [localText, setLocalText] = useState<string | null>(null)
  const [isFiltering, setIsFiltering] = useState(false)

  const hasExternalValueChanged = renderedValueKey !== valueKey

  if (hasExternalValueChanged) {
    setRenderedValueKey(valueKey)
    setLocalText(null)
    setIsFiltering(false)
  }

  const currentLocalText = hasExternalValueChanged ? null : localText
  const currentIsFiltering = hasExternalValueChanged ? false : isFiltering
  const inputText = currentLocalText ?? inputValueAsText
  const shouldShowInputValueOverlay =
    renderedValueFromItem !== undefined &&
    !currentIsFiltering &&
    !isFocused &&
    typeof renderedValueFromItem !== 'string'

  return {
    inputText,
    inputValue: shouldShowInputValueOverlay ? '' : inputText,
    isFiltering: currentIsFiltering,
    shouldShowInputValueOverlay,
    clear: () => {
      setLocalText(null)
      setIsFiltering(false)
    },
    commit: (text: string) => {
      setLocalText(text)
      setIsFiltering(false)
    },
    update: (text: string) => {
      setLocalText(text)
      setIsFiltering(text !== inputValueAsText)
    },
  }
}
